(() => {
  const init = (form) => {
    const nativeForm = form.closest('form');
    const steps = [...form.querySelectorAll('[data-z30-step]')];
    const label = form.querySelector('[data-z30-step-label]');
    const name = form.querySelector('[data-z30-step-name]');
    const progress = form.querySelector('[data-z30-progress]');
    const status = form.querySelector('[data-z30-form-status]');
    const stepNames = ['Vorhaben', 'Leistung', 'Länge', 'Höhe', 'Zeitraum', 'Kontaktdaten'];
    let current = Math.max(0, Math.min(steps.length - 1, Number(form.dataset.startStep || 1) - 1));

    const stepIsComplete = (step) => {
      const required = [...step.querySelectorAll('[required]')];
      const radioNames = [...new Set(required.filter((input) => input.type === 'radio').map((input) => input.name))];
      if (radioNames.some((radioName) => !step.querySelector(`input[name="${CSS.escape(radioName)}"]:checked`))) return false;
      return required.filter((input) => input.type !== 'radio').every((input) => input.checkValidity());
    };

    const render = (shouldScroll = false) => {
      steps.forEach((step, index) => {
        const active = index === current;
        step.hidden = !active;
        step.classList.toggle('is-active', active);
      });
      if (label) label.textContent = `Schritt ${current + 1} von ${steps.length}`;
      if (name) name.textContent = stepNames[current] || '';
      if (progress) progress.style.width = `${((current + 1) / steps.length) * 100}%`;
      const next = steps[current].querySelector('.z30-form-next');
      if (next) next.disabled = !stepIsComplete(steps[current]);
      if (status) status.textContent = `${stepNames[current]}, Schritt ${current + 1} von ${steps.length}`;
      if (shouldScroll && window.matchMedia('(max-width: 749px)').matches) form.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    form.addEventListener('change', (event) => {
      if (!event.target.matches('input, select, textarea')) return;
      const next = steps[current].querySelector('.z30-form-next');
      if (next) next.disabled = !stepIsComplete(steps[current]);
    });

    form.addEventListener('click', (event) => {
      const next = event.target.closest('.z30-form-next');
      const back = event.target.closest('.z30-form-back');
      if (next) {
        if (!stepIsComplete(steps[current])) return;
        current = Math.min(steps.length - 1, current + 1);
        render(true);
      }
      if (back) {
        current = Math.max(0, current - 1);
        render(true);
      }
    });

    const selectedValue = (fieldName) => {
      const selected = nativeForm?.querySelector(`input[name="contact[${fieldName}]"]:checked`);
      return selected?.value?.trim() || 'Nicht angegeben';
    };

    nativeForm?.addEventListener('submit', () => {
      const fullName = nativeForm.querySelector('#ContactForm-name')?.value.trim() || 'Nicht angegeben';
      const nameParts = fullName.split(/\s+/).filter(Boolean);
      const lastName = nameParts.at(-1) || 'Nicht angegeben';
      const postcode = nativeForm.querySelector('#ContactForm-postcode')?.value.trim() || 'Nicht angegeben';
      const email = nativeForm.querySelector('#ContactForm-email')?.value.trim() || 'Nicht angegeben';
      const phone = nativeForm.querySelector('#ContactForm-phone')?.value.trim() || 'Nicht angegeben';
      const callback = nativeForm.querySelector('#ContactForm-callback')?.value.trim() || 'Nicht angegeben';
      const notes = nativeForm.querySelector('#ContactForm-notes')?.value.trim() || 'Keine weiteren Angaben';
      const subject = `Anfrage über Zaun030 Shop - ${lastName} | ${postcode}`;
      const subjectField = nativeForm.querySelector('#ContactForm-subject');
      const messageField = nativeForm.querySelector('#ContactForm-message');

      if (subjectField) subjectField.value = subject;
      if (messageField) {
        messageField.value = [
          'ANFRAGE ÜBER DEN ZAUN030 SHOP',
          '',
          `Betreff: ${subject}`,
          '',
          'KONTAKTDATEN',
          `Name: ${fullName}`,
          `E-Mail: ${email}`,
          `Telefonnummer: ${phone}`,
          `Postleitzahl: ${postcode}`,
          `Bevorzugte Kontaktaufnahme: ${callback}`,
          '',
          'PROJEKTANGABEN',
          `Projektart: ${selectedValue('Projektart')}`,
          `Gewünschte Leistung: ${selectedValue('Gewünschte Leistung')}`,
          `Geplante Gesamtlänge: ${selectedValue('Zaunlänge')}`,
          `Gewünschte Höhe: ${selectedValue('Zaunhöhe')}`,
          `Geplanter Zeitraum: ${selectedValue('Zeitraum')}`,
          `Budgetrahmen: ${selectedValue('Budgetrahmen')}`,
          '',
          'WEITERE ANGABEN',
          notes,
          '',
          'Quelle: Kontaktformular im ZAUN030 Shop'
        ].join('\n');
      }
    });

    render(false);
  };
  document.querySelectorAll('[data-z30-project-form]').forEach(init);
})();
